import React, { createContext, useContext } from 'react';

const translations = {
  es: {
    // Header
    simulationAI: 'SimAI',
    idbAse: 'Habilidades de campo',
    live: 'En vivo',
    restart: 'Reiniciar',
    contentManager: 'Gestor de contenido',

    // Loading
    loadingConfig: 'Cargando configuración...',
    restoringConversation: 'Restaurando conversación...',

    // Introduction
    safeguards: 'Salvaguardias ambientales y sociales',
    introTitle1: 'Entrena tus habilidades durante',
    introTitle2: 'una visita de campo',
    introSubtitle: 'AI Companion para desarrollar tu inteligencia emocional y entrenar tus habilidades blandas — comunicación, liderazgo, negociación y más — en conversaciones reales durante una visita de campo. No se evalúa tu conocimiento técnico, sino cómo te comunicas y gestionas la interacción.',
    startPractice: 'Comenzar práctica',
    introCtaBarHint: 'Para avanzar, pulsa el botón verde. Luego elegirás escenario, nivel y habilidad.',
    sessionTime: 'Aproximadamente 10–15 minutos por sesión · Voz y texto',
    introStep1Title: 'Escenario',
    introStep1Desc: 'Elige el sector y nivel del proyecto a supervisar.',
    introStep2Title: 'Nivel',
    introStep2Desc: 'Define la complejidad del desafío.',
    introStep3Title: 'Habilidad',
    introStep3Desc: 'Selecciona qué soft skill quieres practicar.',
    introStep4Title: 'Simulación',
    introStep4Desc: 'Conversa por voz o texto con tu interlocutor.',

    // Scenario selector
    stepXofY: 'Paso {x} de {y}',
    back: 'Volver',
    continue: 'Continuar',
    selectScenario: 'Selecciona un escenario para continuar',
    selectLevel: 'Selecciona un nivel de dificultad',
    chooseScenario: 'Elige un escenario',
    chooseScenarioDesc: 'Selecciona el tipo de proyecto donde realizarás tu visita de campo.',
    difficultyLevel: 'Nivel de dificultad',
    basic: 'Básico',
    intermediate: 'Intermedio',
    advanced: 'Avanzado',
    basicDesc: 'Conversación guiada con un representante cooperativo. Las preguntas clave aparecen como sugerencias.',
    intermediateDesc: 'El representante muestra resistencia parcial y respuestas evasivas. Sin sugerencias automáticas.',
    advancedDesc: 'Múltiples interlocutores, información contradictoria y presión de tiempo. Decisiones con consecuencias.',
    challenges: '{n} desafíos',

    // Skill selector
    chooseSkill: 'Elige tu habilidad',
    chooseSkillDesc: 'Selecciona la competencia que quieres practicar en esta simulación.',
    selectedSkill: 'Habilidad seleccionada',
    startSimulation: 'Iniciar simulación',
    selectSkillToContinue: 'Selecciona una habilidad para continuar',
    definition: 'Definición',
    appliedToSARAS: 'Aplicado al SARAS',
    expectedExamples: 'Ejemplos esperados',

    // Simulation view
    visitContext: 'Contexto de la visita',
    howToStart: 'Cómo empezar',
    howToStartDesc: 'Para comenzar, salúdalo por texto o audio: preséntate como especialista y explícale el motivo de la visita en campo.',
    understood: 'Entendido',
    speaking: 'Hablando',
    listening: 'Escuchando',
    thinking: 'Pensando',
    thinkingDots: 'Pensando...',
    preparingAudio: 'Preparando audio...',
    listeningDots: 'Escuchando...',
    recording: 'Grabando',
    micPermissionTitle: 'Micrófono bloqueado',
    micPermissionBody: 'Tu navegador tiene bloqueado el micrófono para este sitio. Haz clic en el icono del candado o cámara junto a la URL, permite el acceso al micrófono y recarga la página.',
    micPermissionRetry: 'Reintentar',
    micPermissionDismiss: 'Cerrar',
    representativeSpeaking: 'El representante está hablando...',
    speakWhenReady: 'Habla cuando estés listo',
    pressSpace: 'o presiona {key} para hablar',
    stopAudio: 'Detener audio',
    writeTo: 'Escribe tu mensaje...',
    transcribing: 'Transcribiendo...',
    initializing: 'Inicializando...',
    generatingFeedback: 'Generando tu feedback...',
    pleaseWait: 'Un momento por favor...',
    thanksForParticipating: '¡Gracias por participar!',
    redirectingToFeedback: 'Te estamos redirigiendo a tu feedback personalizado...',
    challengeXofY: 'Desafío {x} de {y}',
    coachHint: 'Pista del coach',
    entry: 'Entrada',

    // Sidebar
    scenario: 'Escenario',
    progress: 'Rendimiento',
    route: 'Recorrido',
    coachHintLabel: 'Pista del coach',
    settings: 'Ajustes',
    caseDetail: 'Detalle del caso',
    sessionStages: 'Etapas de la sesión',
    noHints: 'Sin pistas',
    hintsInChallenge: '{n} pista{s} en este desafío',
    yourInterlocutor: 'Tu interlocutor',
    activeTime: 'Tiempo activo',
    turns: 'Turnos',
    exchanges: '{n} intercambios',
    hintsUsed: 'Pistas usadas',
    xOfY: '{x} de {y}',
    visitMoments: 'Momentos de la visita',
    inProgress: 'En curso',
    noMomentsYet: 'Aún no hay momentos registrados. Continúa la conversación.',
    activeNow: 'Activa ahora',
    seenAgo: 'Vista {time}',
    toDiscover: 'Por descubrir',
    noHintsYet: 'Aún no hay pistas disponibles. Continúa la conversación.',
    newThread: 'Nuevo',
    clean: 'Limpiar',
    changeScenario: 'Cambiar escenario',
    newHintAvailable: 'Nueva pista disponible',

    // Visit moments
    presentation: 'Presentación',
    presentationDesc: 'Llegada a las instalaciones y entrevista de inicio con el equipo de planta',
    siteVisit: 'Recorrido por las instalaciones',
    siteVisitDesc: 'Visita a las áreas clave e identificación de riesgos A&S',
    closing: 'Cierre',
    closingDesc: 'Próximos pasos, Plan de Acción A&S y cierre de la visita',

    // Stances
    supportive: 'Colaborativo',
    neutral: 'Neutral',
    resistant: 'Resistente',
    challenging: 'Desafiante',
    open: 'Abierto',
    closed: 'Cerrado',
    skeptical: 'Escéptico',
    conciliatory: 'Conciliador',
    firm: 'Firme',

    // Chat
    conversation: 'Conversación',
    turnCount: '{n} turnos',

    // Email gate (modal antes de seleccionar escenario)
    emailGateTitle: 'Antes de comenzar',
    emailGateSubtitle: 'Necesitamos tu email para continuar',
    emailGateBody: 'Tu email nos permite asociar tu progreso entre sesiones, recibir tu feedback al final y contactarte solo si quedas seleccionado para el focus group.',
    emailGatePrivacy1: 'Tus datos se mantienen privados — no los compartimos con terceros.',
    emailGatePrivacy2: 'No recibirás correos publicitarios. Solo comunicaciones relacionadas con esta práctica.',
    emailGatePrivacy3: 'Podrás eliminar tu información cuando lo solicites.',
    emailGateLabel: 'Tu email',
    emailGateContinue: 'Continuar',
    emailGateRequired: 'El email es obligatorio para continuar.',
    emailGateInvalid: 'Por favor ingresa un email válido.',
    emailGateFooter: 'Al continuar, aceptas que usemos tu email solo con los fines descritos arriba.',

    // Feedback
    simulationResult: 'Resultado de simulación',
    newSimulation: 'Nueva simulación',
    readyAgain: '¿Listo para practicar de nuevo?',

    // Feedback · overrides de títulos de sección (más explícitos para el usuario)
    feedbackHeaderAlternativas: 'Estrategias para tu próxima visita',

    // Feedback survey
    surveyTitle: 'Antes de irte, cuéntanos cómo fue',
    surveySubtitle: 'Te invitamos a completar esta breve encuesta. Tus respuestas nos ayudan a mejorar la simulación.',
    surveyEmail: 'Email',
    surveyEmailHint: 'Lo usamos para identificar tu respuesta y, si lo deseas, contactarte sobre futuras mejoras.',
    surveySubmit: 'Enviar encuesta',
    surveySubmitting: 'Enviando…',
    surveyThanksTitle: '¡Gracias por tu feedback!',
    surveyThanksMessage: 'Hemos registrado tus respuestas. Tu opinión nos ayuda a mejorar la simulación.',
    surveyError: 'No pudimos enviar tu encuesta. Intenta de nuevo.',
    surveyEmailInvalid: 'Ingresa un email válido.',
    surveyEmailRequired: 'El email es obligatorio.',
    surveyMustComplete: 'Completa la encuesta para continuar.',
    surveyRequiredBadge: 'Requerido',
    surveyPendingPill: 'Encuesta pendiente',
    surveyJumpToSurvey: 'Ir a la encuesta',
    surveyUeqRequired: 'Por favor evalúa todos los pares de adjetivos de la sección 1.',
    surveyLikertRequired: 'Por favor responde todas las afirmaciones de la sección 2.',

    // Survey · Sección 1 (UEQ corto)
    surveySection1Title: '1. Experiencia con el sistema',
    surveySection1Instructions: 'Evalúa tu experiencia marcando tu posición entre cada par de adjetivos opuestos.',
    surveyUeqScale1: '1 = totalmente de acuerdo con el término de la izquierda',
    surveyUeqScale7: '7 = totalmente de acuerdo con el término de la derecha',
    ueqObstructive: 'Obstructivo',
    ueqSupportive: 'Asistivo',
    ueqComplicated: 'Complicado',
    ueqEasy: 'Fácil',
    ueqInefficient: 'Ineficiente',
    ueqEfficient: 'Eficiente',
    ueqConfusing: 'Confuso',
    ueqClear: 'Claro',
    ueqBoring: 'Aburrido',
    ueqExciting: 'Emocionante',
    ueqNotInteresting: 'No interesante',
    ueqInteresting: 'Interesante',
    ueqConventional: 'Convencional',
    ueqInnovative: 'Innovador',
    ueqUnattractive: 'Poco atractivo',
    ueqAttractive: 'Atractivo',

    // Survey · Sección 2 (Likert 1–5)
    surveySection2Title: '2. Percepción de la herramienta',
    surveySection2Instructions: 'Escala 1–5: 1 = totalmente en desacuerdo · 5 = totalmente de acuerdo.',
    likertDisagree: 'Totalmente en desacuerdo',
    likertAgree: 'Totalmente de acuerdo',
    likertRealism: 'El escenario y las respuestas del sistema se sintieron realistas.',
    likertFeedback: 'El feedback del sistema me resultó útil para mejorar mis habilidades.',
    likertComfort: 'Me sentí cómodo/a practicando, incluso al cometer errores.',
    likertTone: 'El tono del sistema fue apropiado durante la interacción.',
    likertTrust: 'Confío en que el sistema entendió mis respuestas y respondió de forma adecuada.',
    catCredibility: 'Credibility-learning',
    catSafety: 'Psychological Safety',
    catTrust: 'Trust in AI',

    // Survey · Sección 3 (texto abierto)
    surveySection3Title: '3. ¿Aplicarías lo aprendido aquí en una situación real? ¿Qué otros usos le darías a la herramienta?',
    surveyOpenTextPlaceholder: 'Comparte tu opinión…',

    // Survey · Sección 4 (demografía)
    surveySection4Title: '4. Sobre ti',
    surveySection4Instructions: 'Esta información nos ayuda a entender mejor el perfil de quienes usan la herramienta.',
    surveyDemographicsRequired: 'Por favor completa todos los campos de la sección 4.',
    demoAgeLabel: 'Rango de edad',
    demoCountryLabel: 'País o región',
    demoCountryPlaceholder: 'ej. México, Colombia, España…',
    demoRoleLabel: 'Rol actual',
    demoRolePlaceholder: 'ej. Manager, HR, Analista, Consultor…',
    demoRoleHint: 'Escribe el cargo o función que mejor describa tu rol actual.',
    demoSeniorityLabel: 'Nivel de seniority',
    seniorityJunior: 'Junior',
    seniorityMid: 'Mid',
    senioritySenior: 'Senior',
    seniorityLead: 'Lead',
    demoSectorsLabel: 'Sector(es) en los que trabajas',
    demoSectorsHint: 'Puedes seleccionar más de uno.',
    sectorTech: 'Tecnología y software',
    sectorFinance: 'Servicios financieros y consultoría',
    sectorIndustry: 'Industria, energía y construcción',
    sectorPublic: 'Sector público, salud y educación',
    sectorCommerce: 'Comercio, retail y servicios',
    sectorOther: 'Otro',
    expandAll: 'Expandir todo',
    collapseAll: 'Colapsar todo',
    showExamples: 'Ver ejemplos',
    hideExamples: 'Ocultar ejemplos',

    // Help modal
    howItWorks: 'Cómo funciona la simulación',
    helpIntro: 'Puedes interactuar por {voice} o por {text}.',
    helpSoftSkillsNote: 'Lo que se evalúa son tus habilidades blandas — cómo te comunicas, lideras y gestionas la conversación — no el conocimiento técnico.',
    voice: 'voz',
    text: 'texto',
    phase1: '1. Preséntate y explica tu motivación',
    phase1Desc: 'Inicia la conversación presentándote, explicando tu rol y la razón de la visita al representante del proyecto.',
    phase2: '2. Dos retos de habilidad',
    phase2Desc: 'El representante te planteará dos situaciones para poner a prueba la habilidad blanda que seleccionaste. Responde con empatía y profesionalismo.',
    phase3: '3. Feedback detallado',
    phase3Desc: 'Al finalizar recibirás una evaluación con tus fortalezas, oportunidades de mejora y una puntuación por criterio.',
    restartTutorial: 'Reiniciar tutorial',

    // Misc
    now: 'Ahora',
    ago: 'Hace {n} min',
    spaceKey: 'Espacio',
    occupationalHealth: 'Salud ocupacional',
    yourFeedback: 'Tu feedback',
    listen: 'Escuchar',
    seeMore: 'Ver más ↓',
    seeLess: 'Ver menos ↑',

    // Tutorial
    tutWelcomeTitle: '¡Bienvenido a la simulación!',
    tutWelcomeContent: 'Este breve recorrido te explica las funcionalidades principales de la vista de chat. Puedes saltar el tutorial en cualquier momento.',
    tutAvatarTitle: 'Representante del proyecto',
    tutAvatarContent: 'Aquí verás el avatar del representante con quien interactúas. Los anillos animados indican cuando él está hablando o cuando tú estás grabando.',
    tutContextTitle: 'Contexto del representante',
    tutMicTitle: 'Micrófono',
    tutMicContent: 'Toca este botón para hablar con el representante. La primera vez tu navegador pedirá permiso para usar el micrófono — haz clic en Permitir. Mientras grabas el botón se pone rojo; tócalo de nuevo para detener la grabación y enviar tu mensaje.',
    tutStopTitle: 'Detener audio',
    tutStopContent: 'Cuando el representante esté hablando aparece este botón. Úsalo para interrumpir el audio en cualquier momento.',
    tutTextTitle: 'Entrada de texto',
    tutTextContent: 'Si prefieres escribir, usa este campo de texto. Pulsa Enter o el botón de envío para mandar tu mensaje.',
    tutChatTitle: 'Ver / Ocultar conversación',
    tutChatContent: 'Este botón despliega el historial completo de la conversación. Puedes abrirlo y cerrarlo cuando quieras revisar lo que se ha dicho.',
    tutScenarioTitle: 'Escenario activo',
    tutScenarioContent: 'Aquí se muestra el escenario que seleccionaste: el tipo de proyecto, el nombre y una descripción breve del contexto en el que se desarrolla la simulación.',
    tutTimelineTitle: 'Recorrido de la visita',
    tutProgressTitle: 'Indicador de rendimiento',
    tutProgressContent: 'Esta barra refleja tu rendimiento general en la simulación. Aumenta a medida que demuestras las competencias evaluadas.',
    tutTurnsTitle: 'Turnos del desafío',
    tutTurnsContent: 'Cada segmento representa un turno de conversación que ya transcurrió. Es solo un indicador del avance en número de intercambios, no de tu desempeño.',
    tutHintsTitle: 'Pistas',
    tutHintsContent: 'Si te sientes bloqueado, expande esta sección para recibir orientación contextual.',
    tutSkillsTitle: 'Habilidad',
    tutSkillsContent: 'Aquí puedes ver la habilidad que estás practicando.',
    tutHelpTitle: '¿Necesitas ayuda?',
    tutHelpContent: 'Este ícono abre el panel de ayuda. Desde allí también puedes volver a iniciar este tutorial cuando lo necesites. ¡Eso es todo, buena suerte en tu simulación!',
    jrBack: 'Atrás',
    jrClose: 'Cerrar',
    jrLast: 'Terminar',
    jrNext: 'Siguiente',
    jrNextLabeled: 'Siguiente ({current}/{total})',
    jrOpen: 'Abrir',
    jrSkip: 'Saltar tutorial',

    // Scenario selector extras
    scenarioAndLevel: 'Elige escenario y nivel',
    scenarioAndLevelDesc: 'Selecciona el sector del proyecto y la complejidad del caso que quieres practicar.',
    available: 'disponibles',
    selectedCase: 'Caso seleccionado',
    context: 'Contexto',
    yourInterlocutorLabel: 'Tu interlocutor',
    projectRepresentative: 'Representante del proyecto',
    challengesLabel: 'Desafíos',
    mode: 'Modo',
    voiceAndText: 'Voz y texto',
    backToOptions: 'Volver a opciones',
    selectOne: 'Selecciona uno',
    clickForDetail: 'Click para ver detalle completo',
    canChangeSkill: 'Puedes cambiar de habilidad luego de revisar el caso completo.',
    selectYourSkill: 'Selecciona tu habilidad',
    selectYourSkillDesc: 'Cada simulación enfoca en una soft skill clave. Elige la que quieres fortalecer.',
    skill: 'Habilidad',
    simulation: 'Simulación',
    nAvailable: '{n} disponibles',
    tutContextContent1: 'Debajo del nombre aparecen dos etiquetas: su actitud actual (colaborativo, neutral, resistente…) y la etapa del recorrido en la que te encuentras (recepción, recorrido, oficina…).',
    tutContextContent2: 'Justo debajo aparece el lenguaje corporal del representante, que te da contexto sobre su actitud no verbal.',
    tutContextContent3: 'Y cuando la escena cambia verás un cartel narrativo en ámbar describiendo ese momento (por ejemplo, al pasar de la bienvenida al recorrido por las instalaciones).',
    tutTimelineContent1: 'Esta sección marca los hitos escénicos de la visita (saludo, recorrido por instalaciones, oficina, despedida…).',
    tutTimelineContent2: 'El punto en verde indica el momento actual y los anteriores muestran un check cuando ya transcurrieron. Te sirve como mapa del avance narrativo de la conversación.',

    // Open in new tab (visible only when SARAS is embedded inside an LMS iframe)
    openInFullTab: 'Abrir en pestaña completa',
    openInFullTabTitle: 'Abrir SARAS en una pestaña nueva para tener más espacio',
  },

  en: {
    simulationAI: 'SimAI',
    idbAse: 'Field Skills',
    live: 'Live',
    restart: 'Restart',
    contentManager: 'Content manager',

    loadingConfig: 'Loading configuration...',
    restoringConversation: 'Restoring conversation...',

    safeguards: 'Environmental and social safeguards',
    introTitle1: 'Train your skills during',
    introTitle2: 'a field visit',
    introSubtitle: 'AI Companion to develop your emotional intelligence and train your soft skills — communication, leadership, negotiation and more — in real conversations during a field visit. Your technical knowledge is not evaluated; what matters is how you communicate and manage the interaction.',
    startPractice: 'Start practice',
    introCtaBarHint: 'To continue, tap the green button. You will then choose scenario, level, and skill.',
    sessionTime: 'Approximately 10–15 minutes per session · Voice and text',
    introStep1Title: 'Scenario',
    introStep1Desc: 'Choose the sector and level of the project to supervise.',
    introStep2Title: 'Level',
    introStep2Desc: 'Set the challenge complexity.',
    introStep3Title: 'Skill',
    introStep3Desc: 'Select which soft skill you want to practice.',
    introStep4Title: 'Simulation',
    introStep4Desc: 'Converse by voice or text with your interlocutor.',

    stepXofY: 'Step {x} of {y}',
    back: 'Back',
    continue: 'Continue',
    selectScenario: 'Select a scenario to continue',
    selectLevel: 'Select a difficulty level',
    chooseScenario: 'Choose a scenario',
    chooseScenarioDesc: 'Select the type of project where you\'ll conduct your field visit.',
    difficultyLevel: 'Difficulty level',
    basic: 'Basic',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    basicDesc: 'Guided conversation with a cooperative representative. Key questions appear as suggestions.',
    intermediateDesc: 'The representative shows partial resistance and evasive answers. No automatic suggestions.',
    advancedDesc: 'Multiple interlocutors, contradictory information and time pressure. Decisions with consequences.',
    challenges: '{n} challenges',

    chooseSkill: 'Choose your skill',
    chooseSkillDesc: 'Select the competency you want to practice in this simulation.',
    selectedSkill: 'Selected skill',
    startSimulation: 'Start simulation',
    selectSkillToContinue: 'Select a skill to continue',
    definition: 'Definition',
    appliedToSARAS: 'Applied to SARAS',
    expectedExamples: 'Expected examples',

    visitContext: 'Visit context',
    howToStart: 'How to start',
    howToStartDesc: 'To begin, greet them by text or voice: introduce yourself as the specialist and explain the reason for the field visit.',
    understood: 'Got it',
    speaking: 'Speaking',
    listening: 'Listening',
    thinking: 'Thinking',
    thinkingDots: 'Thinking...',
    preparingAudio: 'Preparing audio...',
    listeningDots: 'Listening...',
    recording: 'Recording',
    micPermissionTitle: 'Microphone blocked',
    micPermissionBody: 'Your browser has blocked the microphone for this site. Click the lock or camera icon next to the URL, allow microphone access, and reload the page.',
    micPermissionRetry: 'Retry',
    micPermissionDismiss: 'Close',
    representativeSpeaking: 'The representative is speaking...',
    speakWhenReady: 'Speak when ready',
    pressSpace: 'or press {key} to speak',
    stopAudio: 'Stop audio',
    writeTo: 'Write your message...',
    transcribing: 'Transcribing...',
    initializing: 'Initializing...',
    generatingFeedback: 'Generating your feedback...',
    pleaseWait: 'Just a moment please...',
    thanksForParticipating: 'Thanks for participating!',
    redirectingToFeedback: 'Redirecting you to your personalized feedback...',
    challengeXofY: 'Challenge {x} of {y}',
    coachHint: 'Coach hint',
    entry: 'Entrance',

    scenario: 'Scenario',
    progress: 'Performance',
    route: 'Route',
    coachHintLabel: 'Coach hint',
    settings: 'Settings',
    caseDetail: 'Case details',
    sessionStages: 'Session stages',
    noHints: 'No hints',
    hintsInChallenge: '{n} hint{s} in this challenge',
    yourInterlocutor: 'Your interlocutor',
    activeTime: 'Active time',
    turns: 'Turns',
    exchanges: '{n} exchanges',
    hintsUsed: 'Hints used',
    xOfY: '{x} of {y}',
    visitMoments: 'Visit moments',
    inProgress: 'In progress',
    noMomentsYet: 'No moments recorded yet. Continue the conversation.',
    activeNow: 'Active now',
    seenAgo: 'Seen {time}',
    toDiscover: 'To discover',
    noHintsYet: 'No hints available yet. Continue the conversation.',
    newThread: 'New',
    clean: 'Clear',
    changeScenario: 'Change scenario',
    newHintAvailable: 'New hint available',

    presentation: 'Presentation',
    presentationDesc: 'Arrival at the facilities and initial meeting with the plant team',
    siteVisit: 'Site visit',
    siteVisitDesc: 'Visit to key areas and E&S risk identification',
    closing: 'Closing',
    closingDesc: 'Next steps, E&S Action Plan and visit closure',

    supportive: 'Supportive',
    neutral: 'Neutral',
    resistant: 'Resistant',
    challenging: 'Challenging',
    open: 'Open',
    closed: 'Closed',
    skeptical: 'Skeptical',
    conciliatory: 'Conciliatory',
    firm: 'Firm',

    conversation: 'Conversation',
    turnCount: '{n} turns',

    // Email gate (modal before scenario selection)
    emailGateTitle: 'Before we start',
    emailGateSubtitle: 'We need your email to continue',
    emailGateBody: 'Your email lets us link your progress across sessions, receive your feedback at the end and contact you only if you are selected for the focus group.',
    emailGatePrivacy1: 'Your data stays private — we don\'t share it with third parties.',
    emailGatePrivacy2: 'You won\'t get promotional emails. Only communications related to this practice.',
    emailGatePrivacy3: 'You can request to delete your information at any time.',
    emailGateLabel: 'Your email',
    emailGateContinue: 'Continue',
    emailGateRequired: 'Email is required to continue.',
    emailGateInvalid: 'Please enter a valid email.',
    emailGateFooter: 'By continuing, you agree we use your email only for the purposes described above.',

    simulationResult: 'Simulation result',
    newSimulation: 'New simulation',
    readyAgain: 'Ready to practice again?',

    // Feedback · section title overrides (more explicit for the user)
    feedbackHeaderAlternativas: 'Strategies for your next visit',

    // Feedback survey
    surveyTitle: 'Before you go, tell us how it went',
    surveySubtitle: 'We invite you to complete this short survey. Your answers help us improve the simulation.',
    surveyEmail: 'Email',
    surveyEmailHint: 'We use it to identify your response and, if you wish, reach out about future improvements.',
    surveySubmit: 'Submit survey',
    surveySubmitting: 'Submitting…',
    surveyThanksTitle: 'Thanks for your feedback!',
    surveyThanksMessage: 'We have recorded your answers. Your input helps us improve the simulation.',
    surveyError: 'We could not submit your survey. Please try again.',
    surveyEmailInvalid: 'Please enter a valid email.',
    surveyEmailRequired: 'Email is required.',
    surveyMustComplete: 'Complete the survey to continue.',
    surveyRequiredBadge: 'Required',
    surveyPendingPill: 'Survey pending',
    surveyJumpToSurvey: 'Jump to survey',
    surveyUeqRequired: 'Please rate every adjective pair in section 1.',
    surveyLikertRequired: 'Please answer every statement in section 2.',

    // Survey · Section 1 (short UEQ)
    surveySection1Title: '1. Experience with the system',
    surveySection1Instructions: 'Rate your experience by marking your position between each pair of opposite adjectives.',
    surveyUeqScale1: '1 = fully agree with the term on the left',
    surveyUeqScale7: '7 = fully agree with the term on the right',
    ueqObstructive: 'Obstructive',
    ueqSupportive: 'Supportive',
    ueqComplicated: 'Complicated',
    ueqEasy: 'Easy',
    ueqInefficient: 'Inefficient',
    ueqEfficient: 'Efficient',
    ueqConfusing: 'Confusing',
    ueqClear: 'Clear',
    ueqBoring: 'Boring',
    ueqExciting: 'Exciting',
    ueqNotInteresting: 'Not interesting',
    ueqInteresting: 'Interesting',
    ueqConventional: 'Conventional',
    ueqInnovative: 'Innovative',
    ueqUnattractive: 'Unattractive',
    ueqAttractive: 'Attractive',

    // Survey · Section 2 (Likert 1–5)
    surveySection2Title: '2. Perception of the tool',
    surveySection2Instructions: 'Scale 1–5: 1 = strongly disagree · 5 = strongly agree.',
    likertDisagree: 'Strongly disagree',
    likertAgree: 'Strongly agree',
    likertRealism: 'The scenario and the system responses felt realistic.',
    likertFeedback: 'The system feedback was useful for improving my skills.',
    likertComfort: 'I felt comfortable practicing, even when making mistakes.',
    likertTone: 'The system tone was appropriate throughout the interaction.',
    likertTrust: 'I trust that the system understood my answers and responded appropriately.',
    catCredibility: 'Credibility-learning',
    catSafety: 'Psychological Safety',
    catTrust: 'Trust in AI',

    // Survey · Section 3 (open text)
    surveySection3Title: '3. Would you apply what you learned here in a real situation? What other uses would you give the tool?',
    surveyOpenTextPlaceholder: 'Share your thoughts…',

    // Survey · Section 4 (demographics)
    surveySection4Title: '4. About you',
    surveySection4Instructions: 'This helps us better understand the profile of people using the tool.',
    surveyDemographicsRequired: 'Please complete every field in section 4.',
    demoAgeLabel: 'Age range',
    demoCountryLabel: 'Country or region',
    demoCountryPlaceholder: 'e.g. Mexico, Colombia, Spain…',
    demoRoleLabel: 'Current role',
    demoRolePlaceholder: 'e.g. Manager, HR, Analyst, Consultant…',
    demoRoleHint: 'Type the title or function that best describes your current role.',
    demoSeniorityLabel: 'Seniority level',
    seniorityJunior: 'Junior',
    seniorityMid: 'Mid',
    senioritySenior: 'Senior',
    seniorityLead: 'Lead',
    demoSectorsLabel: 'Sector(s) you work in',
    demoSectorsHint: 'You can select more than one.',
    sectorTech: 'Technology and software',
    sectorFinance: 'Financial services and consulting',
    sectorIndustry: 'Industry, energy and construction',
    sectorPublic: 'Public sector, health and education',
    sectorCommerce: 'Commerce, retail and services',
    sectorOther: 'Other',
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
    showExamples: 'Show examples',
    hideExamples: 'Hide examples',

    howItWorks: 'How the simulation works',
    helpIntro: 'You can interact by {voice} or {text}.',
    helpSoftSkillsNote: 'What is evaluated are your soft skills — how you communicate, lead and manage the conversation — not technical knowledge.',
    voice: 'voice',
    text: 'text',
    phase1: '1. Introduce yourself and explain your motivation',
    phase1Desc: 'Start the conversation by introducing yourself, explaining your role and the reason for the visit to the project representative.',
    phase2: '2. Two skill challenges',
    phase2Desc: 'The representative will present two situations to test the soft skill you selected. Respond with empathy and professionalism.',
    phase3: '3. Detailed feedback',
    phase3Desc: 'At the end you\'ll receive an evaluation with your strengths, areas for improvement and a score per criterion.',
    restartTutorial: 'Restart tutorial',

    now: 'Now',
    ago: '{n} min ago',
    spaceKey: 'Space',
    occupationalHealth: 'Occupational health',
    yourFeedback: 'Your feedback',
    listen: 'Listen',
    seeMore: 'See more ↓',
    seeLess: 'See less ↑',

    tutWelcomeTitle: 'Welcome to the simulation!',
    tutWelcomeContent: 'This brief tour explains the main features of the chat view. You can skip the tutorial at any time.',
    tutAvatarTitle: 'Project representative',
    tutAvatarContent: 'Here you\'ll see the avatar of the representative you\'re interacting with. The animated rings indicate when they\'re speaking or when you\'re recording.',
    tutContextTitle: 'Representative context',
    tutMicTitle: 'Microphone',
    tutMicContent: 'Tap this button to speak with the representative. The first time, your browser will ask permission to use the microphone — click Allow. While recording, the button turns red; tap again to stop recording and send your message.',
    tutStopTitle: 'Stop audio',
    tutStopContent: 'When the representative is speaking, this button appears. Use it to interrupt the audio at any time.',
    tutTextTitle: 'Text input',
    tutTextContent: 'If you prefer typing, use this text field. Press Enter or the send button to submit your message.',
    tutChatTitle: 'Show / Hide conversation',
    tutChatContent: 'This button expands the full conversation history. Open or close it whenever you want to review what\'s been said.',
    tutScenarioTitle: 'Active scenario',
    tutScenarioContent: 'Here you can see the scenario you selected: the project type, name, and a brief description of the simulation context.',
    tutTimelineTitle: 'Visit route',
    tutProgressTitle: 'Performance indicator',
    tutProgressContent: 'This bar reflects your overall performance in the simulation. It increases as you demonstrate the evaluated competencies.',
    tutTurnsTitle: 'Challenge turns',
    tutTurnsContent: 'Each segment represents a conversation turn that has already occurred. It\'s just an indicator of the number of exchanges, not your performance.',
    tutHintsTitle: 'Hints',
    tutHintsContent: 'If you feel stuck, expand this section to get contextual guidance.',
    tutSkillsTitle: 'Skill',
    tutSkillsContent: 'Here you can see the skill you are practicing.',
    tutHelpTitle: 'Need help?',
    tutHelpContent: 'This icon opens the help panel. From there you can also restart this tutorial whenever you need. That\'s all, good luck with your simulation!',
    jrBack: 'Back',
    jrClose: 'Close',
    jrLast: 'Finish',
    jrNext: 'Next',
    jrNextLabeled: 'Next ({current}/{total})',
    jrOpen: 'Open',
    jrSkip: 'Skip tutorial',

    scenarioAndLevel: 'Choose scenario and level',
    scenarioAndLevelDesc: 'Select the project sector and the complexity of the case you want to practice.',
    available: 'available',
    selectedCase: 'Selected case',
    context: 'Context',
    yourInterlocutorLabel: 'Your interlocutor',
    projectRepresentative: 'Project representative',
    challengesLabel: 'Challenges',
    mode: 'Mode',
    voiceAndText: 'Voice and text',
    backToOptions: 'Back to options',
    selectOne: 'Select one',
    clickForDetail: 'Click to see full details',
    canChangeSkill: 'You can change the skill after reviewing the full case.',
    selectYourSkill: 'Select your skill',
    selectYourSkillDesc: 'Each simulation focuses on a key soft skill. Choose the one you want to strengthen.',
    skill: 'Skill',
    simulation: 'Simulation',
    nAvailable: '{n} available',
    tutContextContent1: 'Below the name you\'ll see two labels: their current attitude (supportive, neutral, resistant…) and the stage of the visit you\'re in (reception, tour, office…).',
    tutContextContent2: 'Just below, you\'ll see the representative\'s body language, giving you context about their non-verbal attitude.',
    tutContextContent3: 'And when the scene changes, you\'ll see an amber narrative sign describing that moment (for example, when transitioning from the welcome to the site tour).',
    tutTimelineContent1: 'This section marks the scenic milestones of the visit (greeting, facility tour, office, farewell…).',
    tutTimelineContent2: 'The green dot indicates the current moment and previous ones show a checkmark when they\'ve passed. It serves as a map of the narrative progress of the conversation.',

    // Open in new tab (visible only when SARAS is embedded inside an LMS iframe)
    openInFullTab: 'Open in full tab',
    openInFullTabTitle: 'Open SARAS in a new tab for more space',
  },
};

const I18nContext = createContext({ t: (k) => k, lang: 'es' });

export function I18nProvider({ lang = 'es', children }) {
    const dict = translations[lang] || translations.es;
    const t = (key, params) => {
        let str = dict[key] ?? translations.es[key] ?? key;
        if (params) {
            Object.entries(params).forEach(([k, v]) => {
                str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
            });
        }
        return str;
    };
    return <I18nContext.Provider value={{ t, lang }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
    return useContext(I18nContext);
}
